<template>
  <MovimentCheckLayout
      title="Renovação"
      titleIcon="fa-solid fa-clipboard-check"
      :loading="loading"
      :totalItems="content.items.length"
      :successMoviment="successMoviment"
      loadingText="Aguarde, estamos preparando a renovação..."
      qtyColumnLabel="Renovação"
  >
    <template #success>
      <SuccessMoviment v-if="successMoviment" :rentId="rentId" :movimentId="movimentId"
                       msgSuccess="Renovação processada com sucesso!"/>
    </template>

    <template #periods>
      <div class="mcl-period-pill">
        <span class="mcl-period-label">Locação</span>
        <span class="mcl-period-value">{{ content.periodRentCurrent }}</span>
      </div>
      <div class="mcl-period-pill mcl-period-pill--final">
        <span class="mcl-period-label">Renovação</span>
        <span class="mcl-period-value">{{ content.periodRentRenewed }}</span>
        <button class="mcl-btn-edit" @click="confirmRenewed">
          <i class="fa-solid fa-pen-to-square"></i> Editar
        </button>
      </div>
    </template>

    <template #recalculate>
      <div v-if="hasRule('Rental') || hasRule('PDV')" class="mcl-recalculate">
        <Molded>
          <b-row>
            <b-col xs="12" sm="12" md="12" lg="12" xl="12">
              <RadioGroup title="Recalcular Valor do Produto?" field="periodRenewedRecalculate"
                          :changed="recalculate"
                          :options="[{ text: 'Sim', value: true }, { text: 'Não', value: false }]"
                          v-model="periodRenewedRecalculate"/>
            </b-col>
          </b-row>
        </Molded>
      </div>
    </template>

    <template #rows>
      <tbody v-for="item in content.items" :key="item.productId || item.productFullName">
      <tr class="mcl-tr">
        <td class="mcl-td-product">{{ item.productFullName }}</td>
        <td>
          <div class="mcl-td-desc">
            <InputTextEdit v-model="item.description"/>
          </div>
        </td>
        <td class="mcl-th-center">
          <span class="mcl-qty-badge mcl-qty-badge--rent">{{ item.totalRent }}</span>
        </td>
        <td class="mcl-th-center">
          <span class="mcl-qty-badge mcl-qty-badge--return">{{ item.totalSelected }}</span>
        </td>
        <td class="mcl-th-center">
            <span v-if="!item.isValid" class="mcl-status mcl-status--danger">
              <i class="fa-solid fa-do-not-enter"></i>
            </span>
          <span v-else-if="item.totalSelected < item.totalRent" class="mcl-status mcl-status--warning">
              <i class="fa-solid fa-triangle-exclamation"></i>
            </span>
          <span v-else class="mcl-status mcl-status--success">
              <i class="fa-solid fa-circle-check"></i>
            </span>
        </td>
      </tr>
      <tr v-if="item.patrimony.length > 0" class="mcl-tr-patrimony">
        <td colspan="100" class="mcl-td-patrimony">
          <div v-for="patrimony in sortedPatrimony(item.patrimony)" :key="patrimony.barCode" class="mcl-patrimony-row">
            <PatrimonyBadge :barCode="patrimony.barCode"/>
          </div>
        </td>
      </tr>
      </tbody>
    </template>

    <template #alerts>
      <Alert type="danger" v-if="generateError" style="margin-top:14px;">
        <span>Ocorreu um erro ao processar a renovação. Tente novamente ou entre em contato com o suporte.</span>
      </Alert>
    </template>

    <template #actions>
      <slot></slot>
      <Button _key="btnGenerateOutput" type="success" :disabled="isInvalid"
              title="Gerar Renovação" classIcon="fa-solid fa-circle-check" size="large" :clicked="generate"/>
    </template>

    <template #modals>
      <Modal title="Data Fim" :width="500" v-show="showModal('editRenewed')">
        <DateTime title="Fim" field="endDateHourReturn" format="DD/MM/YYYY HH:mm" type="dateTime"
                  v-model="endDateHourReturn"/>
        <div class="text-right">
          <Button _key="btnEndDateHourRenewed" type="primary" title="Aplicar" classIcon="fa-solid fa-circle-check"
                  size="small" :clicked="editRenewed"/>
        </div>
      </Modal>

      <Modal title="Produtos" :width="1100" v-show="showModal('ItemsRentForRecalculatePrice')">
        <ItemsRentForRecalculatePrice :item="itemSelected"/>
      </Modal>
    </template>
  </MovimentCheckLayout>
</template>

<script>
import MovimentCheckLayout from "../shared/MovimentCheckLayout.vue";
import Molded from "@nixweb/nixloc-ui/src/component/layout/Molded";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import InputTextEdit from "@nixweb/nixloc-ui/src/component/forms/InputTextEdit.vue";
import DateTime from "@nixweb/nixloc-ui/src/component/forms/DateTime";
import RadioGroup from "@nixweb/nixloc-ui/src/component/forms/RadioGroup.vue";
import ItemsRentForRecalculatePrice from "../ItemsRentForRecalculatePrice.vue";
import SuccessMoviment from "../SuccessMoviment.vue";
import PatrimonyBadge from "../shared/PatrimonyBadge.vue";

import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: "CheckRenewed",
  components: {
    MovimentCheckLayout,
    Molded,
    Button,
    Modal,
    Alert,
    InputTextEdit,
    SuccessMoviment,
    DateTime,
    RadioGroup,
    ItemsRentForRecalculatePrice,
    PatrimonyBadge,
  },
  props: {
    rentId: String,
    periodRentRenewed: Object,
  },
  data() {
    return {
      urlCheck: "/api/v1/moviment/generate-renewed/check-renewed",
      urlGenerate: "/api/v1/moviment/generate-renewed/generate",
      content: {items: []},
      endDateHourCurrent: "",
      endDateHourReturn: "",
      loading: true,
      successMoviment: false,
      movimentId: "",
      isInvalid: true,
      periodRenewedRecalculate: false,
      itemSelected: {},
      generateError: false,
    };
  },
  mounted() {
    this.endDateHourReturn = this.periodRentRenewed.endDateHour;
    this.periodRenewedRecalculate = this.userLogged.parameterRental.periodRenewedRecalculate;
    this.checkReturn();
  },
  computed: {
    ...mapGetters("generic", ["showModal"]),
    ...mapState("user", ["userLogged"]),
    ...mapGetters("user", ["hasRule"]),
    ...mapGetters("generateMoviment", ["productSelectedByPeriod"]),
    ...mapState("generateMoviment", ["periodRent", "productRent"]),
  },
  methods: {
    ...mapActions("generic", ["postApi"]),
    ...mapMutations("generic", ["openModal", "removeLoading", "hideModal"]),
    ...mapMutations("generateMoviment", ["cleanProductSelected"]),
    checkReturn() {
      this.loading = true;
      let obj = {
        periodRentCurrent: this.periodRent.fullPeriod,
        periodRentRenewed: this.periodRentRenewed,
        productRent: this.productRent,
        productSelected: this.productSelectedByPeriod,
        periodRenewedRecalculate: this.periodRenewedRecalculate,
      };
      let params = {url: this.urlCheck, obj: obj, notNotifyToast: true};
      this.postApi(params).then((response) => {
        if (response.success) {
          this.content = response.content;
          this.isInvalid = false;
        } else {
          this.isInvalid = true;
        }
        this.loading = false;
      });
    },
    generate() {
      this.content.rentId = this.rentId;
      this.loading = true;
      this.generateError = false;
      let recalculate = {
        periodRenewedRecalculate: this.periodRenewedRecalculate,
      };
      let params = {
        url: this.urlGenerate,
        obj: {...this.content, ...recalculate},
        notNotifyToast: false,
      };
      this.postApi(params).then((response) => {
        if (response.success) {
          this.movimentId = response.content;
          let self = this;
          setTimeout(function () {
            self.successMoviment = true;
            self.loading = false;
            self.cleanProductSelected();
            self.removeLoading(["btnGenerateOutput"]);
          }, 300);
        } else {
          this.loading = false;
          this.generateError = true;
          this.removeLoading(["btnGenerateOutput"]);
        }
      });
    },
    confirmRenewed() {
      this.openModal("editRenewed");
    },
    editRenewed() {
      this.hideModal();
      this.removeLoading(["btnEndDateHourRenewed"]);
      this.periodRentRenewed.endDateHour = this.endDateHourReturn;
      this.checkReturn();
    },
    recalculate() {
      this.checkReturn();
    },
    sortedPatrimony(patrimonies) {
      return [...patrimonies].sort((a, b) => (a.barCode || '').localeCompare(b.barCode || ''));
    },
    teste(item) {
      this.itemSelected = item;
      this.openModal("ItemsRentForRecalculatePrice");
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "timeLineAvailability") {
          this.openModal("timeLineAvailability");
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 15px;
}
</style>